import { Autocomplete, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Tab, Tabs, TextField, Typography } from "@mui/material"
import { useEffect, useMemo, useState } from "react"
import { parse } from 'graphql'
import { gql, useMutation } from "@apollo/client";
import MonacoEditor from '@monaco-editor/react'

export const ElementModal = (props: any) => {

    const [ form, setForm ] = useState<any>({});

    const submit = () => {
        props.onSubmit?.(form)
    }

    useEffect(() => {
        setForm({
            ...props.selected
        })
    }, [props.selected])

    const [activeModule,setActiveModule] = useState<any>(null);
    
    useEffect(() => {

        if(props.modules?.[form?.element?.name]){
            setActiveModule(props.modules?.[form?.element?.name]);
        }else{
            props.getModule?.(form?.element?.name)
        }

    }, [props.modules, JSON.stringify(form)]);

    const moduleFields = useMemo(() => {
        if(!activeModule?.options) return;
        const doc = parse(`scalar Any
            scalar AnyInput
            scalar Void
        ` + activeModule?.options)

        return (doc.definitions.find((a: any) => a.name.value == "Props") as any)?.fields
    }, [activeModule?.options]) 

    useEffect(() => {
        if(!moduleFields) return;
        let script = '() => {\n';
        script += ` const client = useApolloClient();\n`
        script += ' return {\n'
        moduleFields.forEach((field) => {
            if(field.arguments.length > 0){
                script += `     ${field.name.value}: (${field.arguments?.map((arg) => arg.name.value).join(', ')}) => {\n`
                script += `     },\n`
            }else{
                script += `     ${field.name.value}: ,\n`
            }
        })
        script +='  }\n'
        script += '}\n'

        if(!form.options){
            setForm({...form, options: script})
        }
    }, [moduleFields])

    return (
        <Dialog 
            fullWidth
            maxWidth='md'
            open={props.open}
            onClose={props.onClose}>
            <DialogTitle>Add element to view</DialogTitle>
            <DialogContent onKeyDown={(e) => {
                if(e.key == 'Escape') e.stopPropagation();
            }}>
                <Box sx={{
                    paddingTop: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px'
                }}>
                    <Autocomplete
                        value={form.element || ''}
                        onChange={(e, value) => setForm({...form, element: value})}
                        options={props.elements}
                        getOptionLabel={(option) => typeof(option) == 'string' ? option : option.name} 
                        renderInput={(params) => <TextField {...params} size="small" label="Element" />}
                        />
                    
                    {moduleFields?.length > 0 ? (
                    <Box sx={{
                        display: 'flex'
                    }}>
                        <Box sx={{
                            display: 'flex', 
                            gap: '8px',
                            flexDirection: 'column'
                        }}>
                            <Typography fontWeight={"bold"}>Arguments</Typography>
                            {moduleFields?.map((field, ix) => field.arguments?.length > 0 ? (
                                <Box sx={{
                                    display: 'flex',
                                }} key={`field-${ix}`}>
                                    <Box sx={{display: 'flex'}}>
                                        <Typography>{field.name.value}</Typography>
                                        {field.arguments?.map((field, ix) => (
                                            <Chip key={`chip-${ix}`} label={`${field.name.value} : ${field.type.name?.value || '[' +field.type?.type?.name?.value +']'}`} />
                                        ))}
                                    </Box>
                                </Box>
                            ) : (
                                <Typography key={`field-${ix}`}>
                                    {field.name.value}
                                </Typography> 
                            ))}
                        </Box>
                        <Box sx={{
                            flex: 1, 
                            minHeight: '250px',
                            flexDirection: 'column',
                            display: 'flex'
                        }}>
                            <Tabs value={0}>
                                <Tab label="Code" />
                                <Tab label="No-code" />
                                <Tab label="LLM" />
                            </Tabs>
                            <MonacoEditor   
                                language="typescript" 
                                value={form.options}
                                onChange={(e) => {
                                    setForm({
                                        ...form,
                                        options: e
                                    })
                                }} />
                        </Box>
                    </Box>
                    ): null}

                
                </Box>

          
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Cancel</Button>
                <Button onClick={submit} variant="contained">Place</Button>
            </DialogActions>
        </Dialog>
    )
}